import "./App.css";

import RootComponent from "./RootComponent";

const App = () => {
  return <RootComponent />;
};

export default App;
